import { Phone, Download, ChevronDown } from 'lucide-react';

export const Hero = () => {
  const scrollToCalculators = () => {
    document.getElementById('investice')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="hero-section"
      className="pt-20 pb-8 md:pt-24 md:pb-16"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left - Text Content */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mb-6 animate-fade-in">
              <span className="text-white">Finanční kalkulačky</span>
              <br />
              <span className="gradient-text-gold">pro chytré rozhodování</span>
            </h1>

            <p className="text-gray-400 text-lg md:text-xl max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-in delay-100">
              10 profesionálních kalkulaček pro správu vašich financí. Investice, hypotéky, úvěry, rozpočet a další - vše na jednom místě.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start animate-fade-in delay-200">
              <a
                href="https://pancungradi.simplybook.it/v2/#book"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-booking-btn"
                className="btn-gold flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                Rezervovat 15 min hovor ZDARMA
              </a>
              <a
                href="#typeform-section"
                data-testid="hero-plan-btn"
                className="btn-outline flex items-center justify-center gap-2"
              >
                <Download className="w-5 h-5" />
                Získat finanční plán
              </a>
            </div>

            {/* Scroll indicator */}
            <button
              onClick={scrollToCalculators}
              className="hidden lg:flex items-center gap-2 text-gray-500 hover:text-gold transition-colors mt-10 animate-fade-in delay-300"
            >
              <span className="text-sm uppercase tracking-wider">Prozkoumat kalkulačky</span>
              <ChevronDown className="w-4 h-4 animate-bounce" />
            </button>
          </div>

          {/* Right - Photo */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2 animate-fade-in">
            <div className="relative">
              {/* Decorative elements */}
              <div className="absolute -inset-4 bg-gradient-to-br from-gold/20 to-green/20 rounded-2xl blur-2xl opacity-50"></div>
              
              {/* Photo container */}
              <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_money-wise-6/artifacts/qgje1shk_C29A8674-3%20%282%29.jpg"
                  alt="Pan Čung - Finanční poradce"
                  className="w-full max-w-md h-auto object-cover"
                  data-testid="hero-image"
                />
                
                {/* Name badge */}
                <div className="absolute bottom-4 left-4 right-4 bg-navy/90 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <p className="font-serif text-xl text-white font-semibold">Pan Čung</p>
                  <p className="text-gold text-sm">Vedu lidi k finanční nezávislosti</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
